export const DEFAULT_CIRCLE_PROBABILITY = 0.3;
export const DEFAULT_QUARTER_CIRCLE_PROBABILITY = 0.45;
export const DEFAULT_RECTANGLE_PROBABILITY = 0.25;
export const DEFAULT_COLOR_VARIETY = 3;
export const DEFAULT_SAME_COLOR_ADJACENCY_WEIGHT = 0.5;
